module.exports = __webpack_public_path__ + "img/CAMERA.cb1a0c11.png";